@import '~style-sheet-helpers/core.less';

.edit-rule-link {
  font-size: 16px;
}
